var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PersonaError } from '../error';
import { EventEmitter } from '../event-emitter';
var AudioRecorder = (function (_super) {
    __extends(AudioRecorder, _super);
    function AudioRecorder() {
        var _this = _super.call(this) || this;
        _this.microphoneStream = null;
        _this.recordingSampleRate = 16000;
        if (navigator.userAgent.includes('Firefox')) {
            _this.browser = 'Firefox';
        }
        else if (navigator.userAgent.includes('Chrome')) {
            _this.browser = 'Chrome';
        }
        else if (navigator.userAgent.includes('Safari')) {
            _this.browser = 'Safari';
        }
        else if (navigator.userAgent.includes('MSIE') ||
            navigator.userAgent.includes('Trident/')) {
            _this.browser = 'IE';
        }
        else {
            _this.browser = 'Unknown';
        }
        _this.recordingSampleRate = _this.browser === 'Firefox' ? 48000 : 16000;
        _this.audioContext = new (window.AudioContext || window.webkitAudioContext)({
            sampleRate: _this.recordingSampleRate,
        });
        return _this;
    }
    AudioRecorder.prototype._initializeAudioRecorder = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, this.setupMicrophone()];
                    case 1:
                        _a.sent();
                        return [4, this.loadAudioProcessor()];
                    case 2:
                        _a.sent();
                        return [3, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.emit('Error', error_1);
                        throw new PersonaError('AUDIO_RECORDER', 'Failed to initialize audio recorder: Permission denied');
                    case 4: return [2];
                }
            });
        });
    };
    AudioRecorder.prototype.setupMicrophone = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4, navigator.mediaDevices.getUserMedia({
                                audio: {
                                    echoCancellation: true,
                                    noiseSuppression: true,
                                    autoGainControl: true,
                                    channelCount: 1,
                                    sampleRate: this.recordingSampleRate,
                                },
                            })];
                    case 1:
                        _a.microphoneStream = _b.sent();
                        this.mediaStreamSource = this.audioContext.createMediaStreamSource(this.microphoneStream);
                        return [3, 3];
                    case 2:
                        error_2 = _b.sent();
                        throw error_2;
                    case 3: return [2];
                }
            });
        });
    };
    AudioRecorder.prototype.loadAudioProcessor = function () {
        return __awaiter(this, void 0, void 0, function () {
            var recordingAudioProcessorCode, recordingAudioProcessorBlob, recordingAudioProcessorUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        recordingAudioProcessorCode = "\n\t  class RecordingAudioProcessor extends AudioWorkletProcessor {\n\t    constructor() {\n\t      super();\n\t      this.buffer = [];\n\t    }\n\n\t    process(inputs, outputs, parameters) {\n\t      if (!inputs[0] || !inputs[0][0]) {\n\t        console.error('Invalid or empty audio input');\n\t        return false; // Stop processing if input is not valid\n\t      }\n\n\t      const input = inputs[0][0];\n\n\t      // Convert float samples to Int16\n\t      let int16Array = new Int16Array(input.length);\n\t      for (let i = 0; i < input.length; i++) {\n\t        int16Array[i] = input[i] * 0x7FFF;\n\t      }\n\n\t      // Buffer the converted data; You could send this to the main thread later\n\t      this.buffer.push(int16Array);\n\n\t      // If we've buffered enough, send to the main thread (example)\n\t      if (this.buffer.length > 4) {\n\t        // Using reduce to concatenate arrays\n\t        let concatenatedBuffer = this.buffer.reduce((acc, val) => {\n\t          let tmp = new Int16Array(acc.length + val.length);\n\t          tmp.set(acc);\n\t          tmp.set(val, acc.length);\n\t          return tmp;\n\t        }, new Int16Array());\n\n\t        this.port.postMessage(concatenatedBuffer.buffer);\n\t        this.buffer = [];\n\t      }\n\n\t      return true;\n\t    }\n\t  }\n\n\t  registerProcessor('my-recording-processor', RecordingAudioProcessor);\n\t";
                        recordingAudioProcessorBlob = new Blob([recordingAudioProcessorCode], { type: 'text/javascript' });
                        recordingAudioProcessorUrl = URL.createObjectURL(recordingAudioProcessorBlob);
                        return [4, this.audioContext.audioWorklet.addModule(recordingAudioProcessorUrl)];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    AudioRecorder.prototype._startRecording = function () {
        var _this = this;
        if (!this.microphoneStream)
            throw new PersonaError('AUDIO_RECORDER', 'Microphone stream not available.');
        this.audioWorkletNode = new AudioWorkletNode(this.audioContext, 'my-recording-processor');
        this.mediaStreamSource.connect(this.audioWorkletNode);
        this.audioWorkletNode.connect(this.audioContext.destination);
        this.audioWorkletNode.port.onmessage = function (event) {
            var data = {
                fileBuffer: new Uint8Array(event.data),
                mimeType: 'pcm',
            };
            _this.emit('UserSpeechChunk', data);
        };
    };
    AudioRecorder.prototype._stopRecording = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, track;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.audioWorkletNode) {
                            this.audioWorkletNode.disconnect();
                        }
                        if (this.mediaStreamSource) {
                            this.mediaStreamSource.disconnect();
                        }
                        return [4, this.audioContext.close()];
                    case 1:
                        _b.sent();
                        if (this.microphoneStream) {
                            for (_i = 0, _a = this.microphoneStream.getTracks(); _i < _a.length; _i++) {
                                track = _a[_i];
                                track.stop();
                            }
                            this.microphoneStream = null;
                        }
                        return [2];
                }
            });
        });
    };
    return AudioRecorder;
}(EventEmitter));
export default AudioRecorder;
